import React from 'react';
import { Box, Text, VStack, Flex, Circle } from '@chakra-ui/react';

interface WaitingToRecordProps {
  recordingTime: number;
  formatTime: (seconds: number) => string;
  formatMaxTime: (seconds: number) => string;
  MAX_RECORDING_TIME: number;
  handleStartRecording: () => void;
  isMobile: boolean;
}

function PendingPermission({
  recordingTime,
  formatTime,
  formatMaxTime,
  MAX_RECORDING_TIME,
  handleStartRecording,
  isMobile,
}: WaitingToRecordProps) {
  return (
    <>
      <Flex justify="center" align="center" py={isMobile ? '60px' : '40px'}>
        <VStack spacing={isMobile ? '12px' : '8px'}>
          <Text fontSize={isMobile ? '32px' : '18px'} fontWeight="bold" color="purple.300">
            {formatTime(recordingTime)}
          </Text>
          <Text fontSize={isMobile ? '18px' : '14px'} color="gray.500">
            Tempo máximo
          </Text>
        </VStack>
      </Flex>

      <Flex justify="center" align="center" pb={isMobile ? '60px' : '40px'}>
        <Box position="relative">
          <Circle
            size={isMobile ? '100px' : '70px'}
            border={isMobile ? '4px solid' : '3px solid'}
            borderColor="purple.200"
            bg="transparent"
            position="absolute"
            top={isMobile ? '-7px' : '-5px'}
            left={isMobile ? '-7px' : '-5px'}
          />
          <Circle
            size={isMobile ? '86px' : '60px'}
            border={isMobile ? '3px solid' : '2px solid'}
            borderColor="white"
            bg="purple.200"
            cursor="pointer"
            _hover={{ bg: 'purple.300' }}
            onClick={handleStartRecording}
            boxShadow="0 4px 20px rgba(0, 0, 0, 0.15)"
            position="relative"
            zIndex="1"
          />
        </Box>
      </Flex>
    </>
  );
}

export { PendingPermission };
